module.exports = __webpack_public_path__ + "img/no-data-symbol.80026718.svg";